import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { GroupIntegrationsModel } from 'app/models/group-integrations.model';
import { GroupService } from 'app/services/group.service';
import { Observable } from 'rxjs';

@Injectable()
export class GroupIntegrationsResolver implements Resolve<GroupIntegrationsModel> {

    constructor(private service: GroupService, private router: Router) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<GroupIntegrationsModel> {
        return this.service.GetGroupIntegrations(route.parent.params.group_id);                
    }
}